import { Injectable, inject } from '@angular/core'

import { Observable, from, tap } from 'rxjs'

import { ViewTasksFilter, fetchViewTasks, getEnumsAndFilters, initService } from '@flowx/core-sdk'

import { PublicTasksService } from './public-tasks.service'

import {
  TMEnumerations,
  TMFilterOperators,
  TMPaginatedResponse,
  TMSetupOptions,
  TMSort,
  TMView,
  TMViewTask,
} from '../public.dictionary'

@Injectable()
export class TasksService {
  #publicTaskService = inject(PublicTasksService)
  #tasksApiPath: string

  initService(initConfig: TMSetupOptions): Observable<void> {
    return from(initService(initConfig))
  }

  fetchEnumerationsAndSetFilters(view: TMView): Observable<{
    enumerations: TMEnumerations
    filterOperators: TMFilterOperators
  }> {
    return from(getEnumsAndFilters(view)).pipe(
      tap(({ enumerations, filterOperators }) => {
        this.#publicTaskService.setEnumerations(enumerations)
        this.#publicTaskService.setFilterOperators(filterOperators)
      })
    )
  }

  setTasksApiPath(path: string): void {
    this.#tasksApiPath = path
  }

  getViewTasks(
    page: number,
    sort: TMSort[],
    filters: ViewTasksFilter[],
    keyword: string,
    size: number
  ): Observable<TMPaginatedResponse<TMViewTask>> {
    return from(
      fetchViewTasks(
        sort,
        filters,
        keyword,
        this.#publicTaskService.getView(),
        {
          page,
          size,
        },
        this.#publicTaskService.getEnumerations(),
        this.#tasksApiPath
      )
    )
  }
}
